var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicePhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.237,
    height: 19.23,
    viewBox: "0 0 12.237 19.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.989,1.509,9.248,1.5A1.753,1.753,0,0,0,7.5,3.248V18.981A1.753,1.753,0,0,0,9.248,20.73h8.741a1.753,1.753,0,0,0,1.748-1.748V3.248a1.746,1.746,0,0,0-1.748-1.739Zm0,15.725H9.248V5h8.741Z",
    transform: "translate(-7.5 -1.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePhone);
export default __webpack_public_path__ + "static/media/devicePhone.ac658c5c74a692d62db29e2259225b3d.svg";
export { ForwardRef as ReactComponent };